import React from 'react';

function Blog() {
	return (
		<div className='blogwrap'>
			<div className='blog-head'>Welcome</div>
			<div className='blog-head2'>Blog 1 / 2</div>
			<div className='blog-author'>by: C.Robs (9/10/2026)</div>
			<div className='blog-body'>
				<div className='blog-line'>
					There's this feeling I get when someone asks me "who is this?" when I
					get my turn on the aux. It's like a mix of satisfaction, joy, and
					pride that rushes through my brain all at once. Showing people a new
					song or artist that they immediately love is a high unlike any other.
					You can get that little dopamine hit when you nail the timing of
					queuing up Doses & Mimosas or some 2000s banger that people "haven't
					heard since high school". But when you drop that song with 10k listens
					from the artist with two other tracks up and everyone in the car is
					immediately vibing, there's just no comparison. Yeah yeah, I'm that "I
					heard them before they got big" type. HOWEVER, I like to think I'm not
					quite as snoody as some of those people can be. Probably.
				</div>
				<div className='blog-line'>
					I used to spend hours every day in middle/high school burning CDs,
					searching through YouTube and Myspace pages, and waiting to hear the
					new local contestants in the "Hometown for the Holidays" competition.
					Zombies Ate My Neighbors by Single File, Always by Fulcrum, Typical by
					Tickle Me Pink, American Trash by InnerPartySystem... the list goes on
					for the local talent that blessed my eardrums thanks to Channel 93.3.
					I found electronic artists by searching through the lineups of old
					festivals such as Skylab, Frostbite, or Hallow-freak'n-ween.
					SoundCloud was a website that actually seemed to value new artists and
					provided a platform for anyone to be heard instead of using a pay for
					plays/promotion focused strategy. Of course, you can't forget
					ThisSongIsSick taking over the EDM blog scene and introducing so many
					of us to current day giants like Pretty Lights or Big Gigantic. It
					used to feel like the search for new music was just as exciting as
					finding your new favorite song.{' '}
				</div>
				<div className='blog-line'>
					As the access and availability to listen and share music grows through
					streaming platforms and social media, it's felt like the community and
					connection of finding new artists has faded away. It's not uncommon
					for a band or artist to spark a viral video or soundclip that gets
					heard by millions of people, but not even a fraction of a percentage
					of those listeners know who they're listening to. New bands seem to
					follow a basic template when it comes to releasing content online by
					following the trends that have been posted to death by every F-list
					"influencer". I know, I know, I'm just digging myself into a deeper
					hole of the 'Unc' that reminises on the good ol' days when everything
					was so much better. Let me go back just a little. I think it's amazing
					how easy it is for a band to post their content and allow access for
					billions of people online to hear their new song. I absolutely fall
					victim to watching the "Feeding our drummer his dinner" videos where
					the rest of the band tosses a white Monster and pack of cigarettes
					into a dark hole. Some of them are hilarious.
				</div>
				<div className='blog-line'>
					My point I'm trying to make here is that the connection I feel towards
					these new bands/artists is weak and easily forgotten. There's several
					songs on my playlists that I heard from a viral video, followed the
					link to their Spotify, listened a couple times and then forgot it
					existed. Once again, there's nothing necessarily wrong with this. I'm
					sure there's plenty of people that are just happy someone clicked on
					the "follow" button and that's all they could ask for. But when you
					find that unique connection with one artist over all the others, it's
					what keeps me coming back for each and every single. For example, when
					Beatport Remix Contests were the massive thing for producers, one of
					my entries was on the "You Got To Go" contest by Above and Beyond. It
					was the first contest I had entered where I actually received some
					votes and moved up near the top 20. However, there was a brand new
					artist by the name of Seven Lions that topped the list with what I
					remember being the most unique, emotional, and creative style of
					electronic I had heard at the time. From then, even though Seven Lions
					probably never listened to my remix, I've felt this connection with
					everything he releases. It didn't take a big team, it didn't take
					paying for instagram promotion, it was just connection through the
					music and the process.
				</div>
				<div className='blog-line'>
					Now, the process feels forced and pre-determined. Make the music, make
					the reels, post on Instagram, Tik Tok, Soundcloud, Distrokid, etc.,
					rinse and repeat. There's some deviation, such as joining your
					favorite producer's Twitch stream and paying them $10 to react on
					their live stream, or dropping a few hundred dollars worth of ads to
					force your way into algorithms, or potentially even set up a fake,
					Boiler Room type dj set where you invite all your friends to stand on
					the wrong side of the DJ booth and dance around for the duration of
					the stream and spend the next year taking clips of pre-recorded
					mashups from that set to post on your profiles.{' '}
				</div>
				<div className='blog-line'>
					Personally, I want more ways to find music that makes it feel like it
					wasn't forced onto my screen. I want the community aspect of sharing
					music back and to find new artists from people, not promotional ads. I
					want to talk about the rise of genres, the downfalls of old bands, and
					unique stories from concerts that people attended. I want to get that
					feeling of showing someone a new band they love and hear about the
					upcoming local scene. So for now, I created a social media page and a
					website with the hopes that maybe one day, it'll bring like minded
					people to one place to share all these things. I don't expect...
					really anything at this point except to write, share my ideas to the
					couple friends who follow, and to see what happens. So here's to
					music.
				</div>
				-C.Robs
			</div>
		</div>
	);
}

export default Blog;
